import { createIcon } from '@chakra-ui/icons';

export const Bookmarks = createIcon({
  displayName: 'Bookmarks',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_916_24019)">
        <path
          d="M10.125 0H4.875C4.57663 0 4.29048 0.118526 4.0795 0.329505C3.86853 0.540483 3.75 0.826631 3.75 1.125V1.5H7.125C7.82119 1.5 8.48887 1.77656 8.98116 2.26884C9.47344 2.76113 9.75 3.42881 9.75 4.125V8.12625L10.626 8.9055C10.6801 8.9535 10.7468 8.98485 10.8183 8.99578C10.8897 9.00672 10.9628 8.99677 11.0287 8.96713C11.0947 8.9375 11.1506 8.88943 11.1899 8.82874C11.2291 8.76804 11.25 8.69729 11.25 8.625V1.125C11.25 0.826631 11.1315 0.540483 10.9205 0.329505C10.7095 0.118526 10.4234 0 10.125 0Z"
          fill="currentColor"
        />
        <path
          d="M7.125 3H1.875C1.57663 3 1.29048 3.11853 1.0795 3.3295C0.868527 3.54048 0.75 3.82663 0.75 4.125V11.625C0.749981 11.6973 0.770854 11.768 0.810107 11.8287C0.84936 11.8894 0.905319 11.9375 0.97125 11.9671C1.03718 11.9968 1.11027 12.0067 1.18173 11.9958C1.25318 11.9849 1.31995 11.9535 1.374 11.9055L4.5 9.12675L7.626 11.9055C7.68005 11.9535 7.74682 11.9849 7.81827 11.9958C7.88973 12.0067 7.96282 11.9968 8.02875 11.9671C8.09468 11.9375 8.15064 11.8894 8.18989 11.8287C8.22915 11.768 8.25002 11.6973 8.25 11.625V4.125C8.25 3.82663 8.13147 3.54048 7.9205 3.3295C7.70952 3.11853 7.42337 3 7.125 3Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_916_24019">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
